import { render, staticRenderFns } from "./mcard.vue?vue&type=template&id=79e556d9&scoped=true&"
import script from "./mcard.vue?vue&type=script&lang=js&"
export * from "./mcard.vue?vue&type=script&lang=js&"
import style0 from "./mcard.vue?vue&type=style&index=0&id=79e556d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e556d9",
  null
  
)

export default component.exports